import { FC } from "react";
import classNames from "classnames";

import { IGoodsInfo } from "@/services/order";

interface SelectSeatProps {
  seats?: Partial<IGoodsInfo>[];
  value?: { id: string; amount: number };
  onChange?: (value: { id: string; amount: number }) => void;
}

/**
 * 席位选择
 * @returns
 */
const SelectSeat: FC<SelectSeatProps> = ({ seats, value, onChange }) => {
  return (
    <div className="grid grid-cols-4 gap-[24px] select-none">
      {seats?.map((item) => (
        <div
          key={item.goodsId}
          className={classNames(
            "flex flex-col justify-center items-center rounded-lg border-[2px] cursor-pointer h-[120px] relative",
            value?.id === item.goodsId! && "bg-primary-50 border-primary-200"
          )}
          onClick={() => {
            onChange?.({
              id: item.goodsId!,
              amount: item.amount!,
            });
          }}
        >
          <div className="ml-[3px] text-[14px] text-text-regular">
            {item.goodsName}
          </div>
          <div className="mt-4 flex flex-row items-end leading-none text-primary-800">
            <div className="text-[16px]">¥</div>
            <div className="font-[DIN] text-[32px]">{item.amount}</div>
          </div>
          {item.description && (
            <div
              style={{
                background: "linear-gradient(265deg, #F89986 0%, #EC7057 100%)",
              }}
              className="h-[24px] w-[68px] py-[3px] px-[10px] absolute left-[-2px] top-[-8px] text-[12px] rounded-tl-xl rounded-br-xl text-white flex flex-row justify-center items-center"
            >
              {item.description}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SelectSeat;
